/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-27 14:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { TextStyle, Icon } from '@shopify/polaris';
import { ChevronRightMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import ShopifyFonts from 'src/constants/shopify-fonts.json';
import { MENU_TYPOGRAPHY, FONT_FAMILY_INHERIT } from 'src/constants/theme-settings';
import { ReactComponent as RefreshIcon } from 'src/assets/images/common/refresh.svg';
import { updateElementTypoRespective } from 'src/helpers/shopify-integration-settings-helper';

type Props = {
  formValues: any,
  prefix: string,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class TypographyForm extends Component<ComposedProps> {
  state = {
    error: ''
  };

  handleSelectMenu = menuItem => {
    this.props.updateFieldReducer('activeMenuItem', menuItem.value);
  };

  handleResetTypo = () => {
    const { themeSettingDefaultValue, updateField, formValues } = this.props;
    let settingDB = _.cloneDeep(_.get(formValues, 'setting'));
    let pagination = _.cloneDeep(_.get(formValues, 'pagination'));
    updateField('typography', themeSettingDefaultValue?.typography);

    Object.values(themeSettingDefaultValue?.typography).forEach(typographyPayload => {
      const { setting, isChangedPagination, paginationSetting } = updateElementTypoRespective(
        typographyPayload,
        settingDB,
        pagination
      );

      settingDB = setting;
      if (isChangedPagination) {
      }
      pagination = paginationSetting;
    });

    updateField(`setting`, settingDB);
    updateField('pagination', pagination);
  };

  render() {
    const { i18n, formValues } = this.props;

    const menu = MENU_TYPOGRAPHY.map(item => {
      let fontFamily = _.get(formValues, `typography.${item.keyValue}.fontFamily`);
      const fontStyle = _.get(formValues, `typography.${item.keyValue}.fontStyle`);
      const [style, weight] = fontStyle?.split('-');
      if (!!fontFamily && fontFamily !== FONT_FAMILY_INHERIT) {
        const font = ShopifyFonts.find(font => font?.variants[0]?.family === fontFamily);
        const fontStyleName = font?.variants.find(variant => {
          return variant?.style === style && variant?.weight === weight ? font?.name : '';
        });
        return {
          label: i18n.translate(item.label),
          value: item.value,
          subLabel: `${font?.name}, ${fontStyleName.name}`
        };
      }

      fontFamily = i18n.translate('AdminHTML.ShopifyIntegrationSettings.Form.typography_Inherit');
      return {
        label: i18n.translate(item.label),
        value: item.value,
        subLabel: fontFamily
      };
    });

    return (
      <>
        <div className="typography-section">
          <div style={{ paddingTop: '16px' }}>
            <span className="form-link">
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Form.typography_UserGuide')}
              </TextStyle>
            </span>
          </div>

          <div
            className="menu-container menu-container--no-border-bottom"
            style={{ marginTop: '16px' }}>
            {menu.map((item, index) => {
              return (
                <div
                  className="menu-container__item menu-container__item--start"
                  onClick={() => this.handleSelectMenu(item)}
                  key={index}>
                  <div className="menu-container__item__name menu-container__item__name--column">
                    <p className="typography-section">{item.label}</p>
                    <span className="typography-value">{item.subLabel}</span>
                  </div>
                  <Icon source={ChevronRightMinor} />
                </div>
              );
            })}
          </div>
        </div>
        <div className="btn-reset" onClick={this.handleResetTypo}>
          <RefreshIcon />{' '}
          <span> {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Form.resetTypo')}</span>
        </div>
      </>
    );
  }
}

export default withI18n()(TypographyForm);
